function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomViewChosenByHotelFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 4H4v24h24V4zM4 2a2 2 0 00-2 2v24a2 2 0 002 2h24a2 2 0 002-2V4a2 2 0 00-2-2H4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.857 10.26c-.192.116-.362-.007-.31-.226l.302-1.3-1.01-.875c-.169-.147-.105-.346.12-.365l1.33-.113.518-1.226c.088-.207.297-.207.385 0l.52 1.226 1.33.113c.223.02.288.218.118.365l-1.01.875.304 1.3c.05.22-.119.342-.31.226L16 9.57l-1.143.69zM8.35 10.965c-.013.224.176.315.344.168l1.006-.877 1.246.48c.21.08.354-.07.267-.277l-.525-1.227.842-1.037c.143-.175.044-.36-.18-.34l-1.329.12-.725-1.117c-.123-.188-.328-.151-.378.067L8.62 8.223l-1.29.342c-.217.057-.246.265-.054.38l1.147.687-.073 1.333zM15 22h-4v-2h4v2zM21 22h-4v-2h4v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 27.991V18h1v-2h-4v-2h2v-2H8v2h2v2H6v2h1v9.991H5v1h22v-1h-2zm-2 0h-3V24h-8v3.991H9V18h14v9.991zm-9 0h4V26h-4v1.991zM12 16h8v-2h-8v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.788 10.46c-.088.206.056.357.267.276l1.244-.48 1.006.877c.17.148.358.056.346-.168l-.073-1.333 1.146-.687c.194-.115.163-.323-.053-.38l-1.29-.342-.3-1.298c-.05-.22-.255-.254-.378-.067l-.724 1.117-1.33-.12c-.224-.02-.323.165-.18.34l.842 1.037-.523 1.228z",
    fill: props.color
  }));
}

export default SvgIconRoomViewChosenByHotelFilled;